module.exports = __webpack_public_path__ + "img/imprimir.c2be4e09.svg";